(() => {
  if (customElements.get('pdp-header-cart')) return;
  customElements.define('pdp-header-cart', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const connect = () => {
        const form = document.querySelector('form.pdp-form');
        const main = form?.querySelector('.pdp-form__submit');
        const formId = form?.getAttribute('id');
        if (!formId || !main) return;
        this.observer?.disconnect();
        let button = this.querySelector('button');
        if (!button) {
          const link = this.querySelector('a');
          if (!link) return;
          button = document.createElement('button');
          button.className = link.className;
          button.type = 'submit';
          button.name = 'add';
          link.replaceWith(button);
        }
        button.setAttribute('form', formId);
        const sync = () => {
          button.disabled = main.disabled;
          button.textContent = main.querySelector('[data-add-label]')?.textContent.trim() || main.textContent.trim();
        };
        this.observer = new MutationObserver(sync);
        this.observer.observe(main, { attributes:true, childList:true, subtree:true, characterData:true });
        sync();
      };
      connect();
      document.addEventListener('shopify:section:load', connect, { signal:this.abort.signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
})();
